export default "__VITE_ASSET__CGZzXHfD__"